import React, { useEffect, useContext, useRef } from "react";
import Flex from '@react-css/flex';

export const PendenciaDeAprovacao = (
    {
        pendenciaAprovacao,
        openModalConcluir,
        openModalAprovar,
        openModalReprovar,
        timesheet
    }
) => {
    const checkPrazo = (item) => {
        if (item.statusAprovacao !== "Pendente") return ""
        var diasPassadosEmPorcentagem = item.diasRestantes * 100 / item.prazo
        if (item.diasRestantes < 0) {
            return "error";
        }
        else if (diasPassadosEmPorcentagem <= 70) {
            return "warning";
        }
        else {
            return "success";
        }
    }

    return (
        <>
            <div className="card">
                <Flex className="timesheet-more-infs">
                    <Flex.Item className="flex-column-1">
                        <span className="legend-info">Usuário/Perfil Aprovador</span>
                        <p className="data-info">{pendenciaAprovacao?.nomeAprovador}</p>
                    </Flex.Item>
                    <Flex.Item className="flex-column-3">
                        <p className="data-info"></p>
                    </Flex.Item>
                    <Flex.Item className="flex-column-3">
                        <p className="data-info-legend"></p>
                    </Flex.Item>
                    <Flex.Item className="flex-column-3">
                        <p className="data-info-valor"></p>
                    </Flex.Item>
                    <Flex.Item className="flex-column-2">
                        <span className="legend-info">Etapa da Aprovação</span>
                        <p className="data-info">{pendenciaAprovacao?.nomeEtapa}</p>
                    </Flex.Item>
                    <Flex.Item className="flex-column-5">
                        <span className="legend-info">Status da Aprovação</span>
                        <p className="data-info">{pendenciaAprovacao?.statusAprovacao}</p>
                    </Flex.Item>
                    <Flex.Item className="flex-column-3">
                        <span className="legend-info">Prazo da Aprovação</span>
                        <p className={"data-info prazo-" + checkPrazo(pendenciaAprovacao)}>
                            {pendenciaAprovacao?.dataPrazo} <i className="fa fa-circle" aria-hidden="true"></i>
                        </p>
                    </Flex.Item>
                </Flex>
                <div className="pendencia-de-aprovacao">
                    {
                        pendenciaAprovacao.acoes.reprovar && !pendenciaAprovacao.acoes.notificacaoEsclarecimento && (
                            <input style={{ marginRight: "10px" }} className='default-button-red button-reprovar' value='Reprovar' type="button" onClick={() => openModalReprovar()} />
                        )
                    }
                    {
                        (pendenciaAprovacao.acoes.aprovar && !pendenciaAprovacao.acoes.notificacaoEsclarecimento && (!pendenciaAprovacao.acoes.notificacaoAtividade
                            && !pendenciaAprovacao.acoes.notificacaoGrupoAtividade)) && (
                            <input style={{ marginRight: "10px" }} className='default-button-red button-aprovar' value='Aprovar' type="button" onClick={() => openModalAprovar()} />
                        )
                    }
                    {
                        (pendenciaAprovacao.acoes.concluir && !pendenciaAprovacao.acoes.notificacaoEsclarecimento && (!pendenciaAprovacao.acoes.notificacaoAtividade
                            && !pendenciaAprovacao.acoes.notificacaoGrupoAtividade)) && (
                            <input style={{ marginRight: "10px" }} className='default-button-red button-concluir' value='Concluir' type="button" onClick={() => openModalConcluir()} />
                        )
                    }
                </div>
            </div>
        </>
    );
};
